var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon16PxIdeaOutline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7911 6.33399C11.7957 5.65433 11.6185 4.9858 11.2775 4.3978C10.9366 3.8098 10.4445 3.32378 9.85234 2.99019C9.26016 2.65659 8.58948 2.48758 7.90993 2.50071C7.23038 2.51384 6.56672 2.70862 5.98787 3.06484C5.40901 3.42106 4.93606 3.92573 4.61811 4.52645C4.30015 5.12717 4.14879 5.80205 4.17973 6.48103C4.21067 7.16 4.42278 7.81831 4.79405 8.38763C5.16533 8.95695 5.68222 9.4165 6.29107 9.71861V10.9879C6.29107 11.1001 6.33565 11.2077 6.41499 11.287C6.49433 11.3663 6.60195 11.4109 6.71415 11.4109H9.25261C9.36482 11.4109 9.47243 11.3663 9.55177 11.287C9.63112 11.2077 9.67569 11.1001 9.67569 10.9879V9.71861C10.3082 9.40699 10.8412 8.92515 11.2149 8.32725C11.5886 7.72934 11.7881 7.03906 11.7911 6.33399Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29492 13.5H9.67954",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon16PxIdeaOutline);
export default __webpack_public_path__ + "static/media/icon_16px_idea_outline.6ef7f325b7518c9e53685eedbf2cca6c.svg";
export { ForwardRef as ReactComponent };